var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" }
        },
        [
          _c("el-input", {
            staticStyle: { flex: "1" },
            attrs: { disabled: _vm.disabled },
            model: {
              value: _vm.cargoDoc.notifyCode,
              callback: function($$v) {
                _vm.$set(_vm.cargoDoc, "notifyCode", $$v)
              },
              expression: "cargoDoc.notifyCode"
            }
          }),
          _c("cargo-advance-select", {
            staticStyle: { flex: "1" },
            attrs: {
              disabled: _vm.disabled,
              "select-type": _vm.selectTypeNames.basic_data_Company,
              "method-params": { notify: true, active: true },
              filterable: "",
              "default-value": _vm.cargoDoc.notifyId || ""
            },
            on: { parentCallBack: _vm.notifyAutoCompleteChange }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-top": "5px" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.disabled },
              on: { click: _vm.onClear }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")) + " ")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "5px" },
              attrs: { type: "primary", disabled: _vm.disabled },
              on: {
                click: function($event) {
                  return _vm.onCopyConsignee(false)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CopyTheConsignee")) + " ")]
          )
        ],
        1
      ),
      _vm._l(7, function(i) {
        return _c("cargo-input", {
          key: i,
          staticStyle: { "margin-top": "5px" },
          attrs: {
            "use-read-only": true,
            disabled: _vm.disabled,
            "auto-uppercase": _vm.autoUppercase,
            "filter-chars": false
          },
          on: {
            change: function($event) {
              return _vm.onChange("notifyLine" + i)
            }
          },
          nativeOn: {
            dblclick: function($event) {
              _vm.showAdvanceTextDialog(
                _vm.$t("SeaExport.NotifyParty"),
                _vm.mergeNotifyLine(),
                _vm.splitNotifyLine,
                _vm.autoUppercase,
                { autoHalfWord: true, autoUppercase: _vm.autoUppercase }
              )
            }
          },
          model: {
            value: _vm.cargoDoc["notifyLine" + i],
            callback: function($$v) {
              _vm.$set(_vm.cargoDoc, "notifyLine" + i, $$v)
            },
            expression: "cargoDoc['notifyLine'+i]"
          }
        })
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            },
            close: _vm.closeAdvanceText
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              disabled: _vm.disabled,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.disabled,
                      expression: "!disabled"
                    }
                  ],
                  attrs: { no: "advanceTextDialogConfirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                      _vm.closeAdvanceText()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("span", { staticStyle: { color: "#404144", "margin-top": "5px" } }, [
        _vm._v("ALSO NOTIFY")
      ]),
      _c("cargo-rich-textarea", {
        staticStyle: { height: "110px", "margin-top": "5px" },
        attrs: {
          disabled: _vm.disabled,
          "text-chars": 0,
          "wrap-symbol": "r",
          "auto-half-word": "",
          "auto-uppercase": _vm.autoUppercase
        },
        model: {
          value: _vm.cargoDoc.alsoNotify,
          callback: function($$v) {
            _vm.$set(_vm.cargoDoc, "alsoNotify", $$v)
          },
          expression: "cargoDoc.alsoNotify"
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }